export const sectionLayout = {
    content: 'content',
    form: 'form',
} as const;

export type TSectionLayout = typeof sectionLayout[keyof typeof sectionLayout];
